var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoginSource, SCREEN_SIZE } from '../../../classes/enums';
import { HasSubscriptions } from '../../has-subscriptions';
import { CommunicationService } from '../../../services/communication.service';
import { StaticPathPipe } from '../../../shared/pipes/static-path.pipe';
var PromotionalOverlayComponent = /** @class */ (function (_super) {
    __extends(PromotionalOverlayComponent, _super);
    function PromotionalOverlayComponent(_translateService, communicationService, staticPathPipe) {
        var _this = _super.call(this) || this;
        _this._translateService = _translateService;
        _this.communicationService = communicationService;
        _this.staticPathPipe = staticPathPipe;
        _this.PageTitleMap = new Map([
            [LoginSource.Generic, { title: '', subtitle: '' }],
            [LoginSource.HomeEstimator,
                { title: _this._translateService.instant('home-estimator.best-home-estimator'),
                    subtitle: [_this._translateService.instant('home-estimator.leading-estimator'), _this._translateService.instant('home-estimator.estimates-are-for-free'), _this._translateService.instant('home-estimator.contact-agent-for-valuation')] }
            ],
            [LoginSource.Radar,
                { title: _this._translateService.instant('registration.join-remax-radar'),
                    subtitle: [_this._translateService.instant('registration.radar-customized-experience'), _this._translateService.instant('registration.radar-receive-email'), _this._translateService.instant('registration.radar-opt-out')] }
            ]
        ]);
        _this.hideContent = false;
        _this.LoginUsage = LoginSource;
        _this.backgroundImage = {};
        _this.sourcePage = LoginSource.Generic;
        return _this;
    }
    PromotionalOverlayComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setPageTitle();
        this.addSub(this.communicationService.screenSize.subscribe(function (screenSize) {
            _this.screenSize = screenSize;
            _this.hideContent = screenSize <= SCREEN_SIZE.MOBILE_ONLY && _this.sourcePage === LoginSource.Generic ? true : false;
            _this.backgroundImage = _this.addStyle();
        }));
    };
    PromotionalOverlayComponent.prototype.setPageTitle = function () {
        this.title = this.PageTitleMap.get(this.sourcePage).title;
        this.description = this.PageTitleMap.get(this.sourcePage).subtitle;
    };
    PromotionalOverlayComponent.prototype.addStyle = function () {
        if (this.sourcePage === LoginSource.Radar)
            return this.addBackgroundImage('/assets/login/remax-radar.jpg');
        if (this.sourcePage === LoginSource.Generic)
            return this.addBackgroundImage('/assets/login/generic-promotional.jpg');
        if (this.screenSize >= SCREEN_SIZE.TABLET_LANDSCAPE_UP)
            return this.addBackgroundImage('/assets/home-estimator/home-estimate-banner.jpg', 0.5);
        return this.addBackgroundImage('/assets/home-estimator/home-estimate-banner.jpg', 0.8);
    };
    PromotionalOverlayComponent.prototype.addBackgroundImage = function (url, gradientValue) {
        if (gradientValue === void 0) { gradientValue = 0; }
        var statURL = this.staticPathPipe.transform(url + '?auto=compress,format&q=0');
        if (gradientValue) {
            return {
                'background-image': 'linear-gradient(45deg, rgba(0, 0, 0, ' + gradientValue + '), rgba(0, 0, 0, 0.0)),url(' + statURL + ')'
            };
        }
        else {
            return {
                'background-image': 'url(' + statURL + ')'
            };
        }
    };
    return PromotionalOverlayComponent;
}(HasSubscriptions));
export { PromotionalOverlayComponent };
